import { COLORS as DefaultColors } from "../sub/theme/colors";

const appColors = {
  // VB Brand Colors
  vbNavy: "#003764",
  vbCyan: "#199ad6",
  vbGreen: "#0c8742",
  vbSun: "#ffb81d",
  vbOrange: "#f16122",

  // UI Gray Scale
  uiGray900: "#111827",
  uiGray700: "#374151",
  uiGray600: "#4b5563",
  uiGray500: "#6b7280",
  uiGray400: "#9aa3af",
  uiGray300: "#d1d5db",
  uiGray200: "#e5e7eb",
  uiGray100: "#f3f4f6",

  // Semantic mappings
  primary: "#003764", // vbNavy
  primaryVariant: "#FFF4DD",
  secondary: "#199ad6", // vbCyan
  secondaryTranslucent: "#199ad633",
  secondaryVariant: "#E8F5E8",
  tertiary: "#6b7280", // uiGray500
  tertiaryVariant: "#f3f4f6", // uiGray100
  quaternary: "#003764", // vbNavy
  quaternaryVariant: "#D8F2FF",

  red: "#D3302F",
  redVariant: "#F9E0DF",

  greenLink: "#0c8742", // vbGreen

  background: "#ffffff",
  surface: "#ffffff",
  surfaceVariant: "#e5e7eb", // uiGray200
  inverseSurface: "#111827", // uiGray900

  onPrimary: "#ffffff",

  border: "#d1d5db", // uiGray300

  activeNavItem: "#1271ED",
};

export const COLORS = { ...DefaultColors, ...appColors };
